import React from "react";
import ReactDOM from "react-dom";
import ChatWindow from "./components/ChatWindow";
import "./App.css";
import "./index.css";
import { Provider } from "react-redux";
import store, { persistor } from "./Redux/App/store";
import { PersistGate } from "redux-persist/integration/react";

function initChatWidget(config) {
  // document.addEventListener("DOMContentLoaded", function () {
  (function () {
    // Run on next animation frame to ensure DOM is ready
    requestAnimationFrame(() => {
      const container = document.createElement("div");
      container.id = "chat-widget-container";
      container.className = "dexkor-app";
      document.body.appendChild(container);

      const shadowRoot = container.attachShadow({ mode: "open" });

      // Fetch and apply external CSS
      fetch("https://widget.dexkor.com/static/css/v1/main.css")
        // fetch("http://localhost:8080/static/css/v1/main.css")
        .then((response) => response.text())
        .then((cssText) => {
          // Combine fetched CSS with additional styles
          const combinedCss = `
          ${cssText}
        `;

          // Apply the combined CSS to a new CSSStyleSheet
          const styleSheet = new CSSStyleSheet();
          styleSheet.replaceSync(combinedCss);

          // Apply the constructed stylesheet to the Shadow DOM
          shadowRoot.adoptedStyleSheets = [styleSheet];

          // Render the React component inside the shadow root
          ReactDOM.render(
            <Provider store={store}>
              <PersistGate loading={null} persistor={persistor}>
                <React.StrictMode>
                  <ChatWindow {...config} />
                </React.StrictMode>
              </PersistGate>
            </Provider>,
            shadowRoot
          );
        })
        .catch((error) =>
          console.error("Failed to fetch and inject CSS:", error)
        );
    });
  })();
}

// Expose the initChatWidget function to the global window object
window.initChatWidget = initChatWidget;
